import { createRouter, createWebHistory } from 'vue-router'
import Login from './views/auth/Login.vue'
import AuthLayout from './layouts/AuthLayout.vue'
import MainLayout from './layouts/MainLayout.vue'
import Plan from './views/plan/Plan.vue'
import OfficeList from './views/office/OfficeList.vue'
import StaffList from './views/staff/StaffList.vue'
import UserList from './views/user/UserList.vue'
import UserEdit from './views/user/UserEdit.vue'
import ImportKaigoNoMori from './views/user/ImportKaigoNoMori.vue'
import ImportKaigoNoMoriSchedule from './views/plan/ImportKaigoNoMori.vue'
import ImportKaigoNoMoriStaff from './views/staff/ImportKaigoNoMoriStaff.vue'
import Repository from './libs/Repository'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import Report from './views/report/Report.vue'
import ReportFree from '@/views/report/ReportFree.vue'
import StaffShift from '@/views/shift/StaffShift.vue'
import StaffShift2 from '@/views/shift/StaffShift2.vue'
import ImportKaigoNoMoriManager from '@/views/staff/ImportKaigoNoMoriManager.vue'
import StaffEdit from './views/staff/StaffEdit.vue'
import InstructionList from '@/views/instruction/InstructionList.vue'
import InstructionEdit from '@/views/instruction/InstructionEdit.vue'
import CustomServiceCodeList from '@/views/custom-service-code/CustomServiceCodeList.vue'
import CustomServiceCodeEdit from '@/views/custom-service-code/CustomServiceCodeEdit.vue'
import SiteUtils from './libs/SiteUtils'
import Sorry from '@/views/error/Sorry.vue'
import NotFound from '@/views/error/NotFound.vue'
import ServerError from '@/views/error/ServerError.vue'
import NetworkError from '@/views/error/NetworkError.vue'
import NetworkTimeout from '@/views/error/NetworkTimeout.vue'
import Code from './views/code/Code.vue'
import TeresaStandardCode from '@/views/code/TeresaStandardCode.vue'
import LoginFree from '@/views/auth/LoginFree.vue'
import OfficeEdit from '@/views/office/OfficeEdit.vue'
import ImportF1User from '@/views/user/ImportF1User.vue'
import PlanEdit from '@/views/plan/PlanEdit.vue'
import DailyShift from '@/views/shift/DailyShift.vue'
import ImportTeresaStandard from './views/user/ImportTeresaStandard.vue'
import ImportTeresaStandardStaff from './views/staff/ImportTeresaStandardStaff.vue'
import ImportTeresaStandardSchedule from '@/views/schedule/ImportTeresaStandard.vue'

const home = SiteUtils.isFree() ? '/report' : '/plan'
const loginComponent = SiteUtils.isFree() ? LoginFree : Login
const reportComponent = SiteUtils.isFree() ? ReportFree : Report

const routes = [
  {
    path: '/login',
    component: AuthLayout,
    children: [
      { path: '', name: 'login', component: loginComponent }
    ]
  },
  {
    path: '/error',
    component: AuthLayout,
    children: [
      { path: 'sorry', component: Sorry },
      { path: 'not-found', component: NotFound },
      { path: 'server-error', component: ServerError },
      { path: 'network-error', component: NetworkError },
      { path: 'network-timeout', component: NetworkTimeout }
    ]
  },
  {
    path: '',
    component: MainLayout,
    redirect: home,
    children: [
      { path: 'home', redirect: home },
      {
        path: '/plan',
        name: 'plan',
        component: Plan,
        meta: { requiresAuth: true }
      },
      {
        path: '/plan/:id',
        name: 'plan_edit',
        component: PlanEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/plan_new',
        name: 'plan_new',
        component: PlanEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/shift/pattern',
        name: 'shift-pattern',
        component: DailyShift,
        meta: { requiresAuth: true }
      },
      {
        path: '/shift/staff',
        name: 'shift-staff',
        component: StaffShift,
        meta: { requiresAuth: true }
      },
      {
        path: '/shift/staff2',
        name: 'shift-staff2',
        component: StaffShift2,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/kaigo-no-mori/manager',
        name: 'import-kaigo-no-mori-manager',
        component: ImportKaigoNoMoriManager,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/kaigo-no-mori/user',
        name: 'import_kaigo_no_mori_user',
        component: ImportKaigoNoMori,
        meta: { requiresAuth: true }
      },
      {
        path: '/office',
        name: 'office',
        component: OfficeList,
        meta: { requiresAuth: true }
      },
      {
        path: '/office/new',
        name: 'office_new',
        component: OfficeEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/office/:id',
        name: 'office_edit',
        component: OfficeEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/staff',
        name: 'staff',
        component: StaffList,
        meta: { requiresAuth: true }
      },
      {
        path: 'report',
        component: EmptyLayout,
        children: [
          {
            path: '',
            name: 'report',
            component: reportComponent,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: '/staff_new',
        name: 'staff_new',
        component: StaffEdit,
        props: { addMode: true },
        meta: { requiresAuth: true }
      },
      {
        path: '/staff/:id',
        name: 'staff_edit',
        component: StaffEdit,
        props: { addMode: true },
        meta: { requiresAuth: true }
      },
      {
        path: '/user',
        name: 'user',
        component: UserList,
        meta: { requiresAuth: true }
      },
      {
        path: '/user_new',
        name: 'user_new',
        component: UserEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/user/:id',
        name: 'user_edit',
        component: UserEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/f1user',
        name: 'import_f1_user',
        component: ImportF1User,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/teresa-standard/user',
        name: 'import_teresa_standard_user',
        component: ImportTeresaStandard,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/kaigo-no-mori/schedule',
        name: 'import_kaigo_no_mori_schedule',
        component: ImportKaigoNoMoriSchedule,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/teresa-standard/schedule',
        name: 'import_teresa_standard_schedule',
        component: ImportTeresaStandardSchedule,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/kaigo-no-mori/staff',
        name: 'import_kaigo_no_mori_staff',
        component: ImportKaigoNoMoriStaff,
        meta: { requiresAuth: true }
      },
      {
        path: '/import/teresa-standard/staff',
        name: 'import_teresa_standard_staff',
        component: ImportTeresaStandardStaff,
        meta: { requiresAuth: true }
      },
      {
        path: '/instruction',
        name: 'instruction_list',
        component: InstructionList,
        meta: { requiresAuth: true }
      },
      {
        path: '/instruction_new',
        name: 'instruction_new',
        component: InstructionEdit,
        props: { addMode: true },
        meta: { requiresAuth: true }
      },
      {
        path: '/instruction/:id',
        name: 'instruction_edit',
        component: InstructionEdit,
        props: { addMode: true },
        meta: { requiresAuth: true }
      },
      {
        path: '/custom-service-code',
        name: 'custom-service-code',
        component: CustomServiceCodeList,
        meta: { requiresAuth: true }
      },
      {
        path: '/custom-service-code_new',
        name: 'custom-service-code_new',
        component: CustomServiceCodeEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/custom-service-code_edit/:id',
        name: 'custom-service-code_edit',
        component: CustomServiceCodeEdit,
        meta: { requiresAuth: true }
      },
      {
        path: '/code',
        name: 'code_list',
        component: Code,
        meta: { requiresAuth: true }
      },
      {
        path: '/teresa-standard-code',
        name: 'teresa-standard-code',
        component: TeresaStandardCode,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    beforeEnter: (to, from, next) => {
      if (to.path.startsWith('/temp/')) {
        window.location.href = to.fullPath
      } else {
        next('/error/not-found')
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Hàm xử lý chuyển hướng về login
const redirectToLogin = (to, next) => {
  Repository.clearToken() // Xóa token khi có lỗi
  next({
    path: '/login',
    query: { redirect: to.fullPath }
  })
}

router.beforeEach((to, from, next) => {
  const token = Repository.getToken()

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      redirectToLogin(to, next)
    } else {
      next()
    }
  } else {
    next()
  }
})

// Xử lý lỗi toàn cục
router.onError((error) => {
  if (error.name === 'ApiError' || error.message.includes('ApiError')) {
    const currentRoute = router.currentRoute.value
    redirectToLogin(currentRoute, (path) => router.push(path))
  }
})

export default router
